{
	"ariaCropArea": "crop area",
	"ariaCropStraightenArea": "crop straighten area",
	"cropHandle": "crop handle {{anchor}}"
}
